import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Typography,
  TextField
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React from "react";

import { useFormik } from 'formik';
import * as yup from 'yup';

import { ReactComponent as DialogAlert } from "../../../assets/images/dialog-alert.svg";
import { ReactComponent as DialogAlertGreen } from "../../../assets/images/dialog-alert-green.svg";
import * as Util from "../../../services/global.service";

import CloseIcon from "../../../assets/images/plus-circle-fill.svg";



const ConfirmRejectPerformanceEvaliation = (props) => {
  const { t } = useTranslation()
  const handleClose = () => {
    props.setValue(false)
    formik.resetForm()
  };

  const validationSchemaReject = yup.object({
    description: yup.string().required(t("label.pleaseFillOutThisField"))
  });
  const validationSchemaApprove = yup.object({
    description: (props.required) ? yup.string().required(t("label.pleaseFillOutThisField")) : yup.string()
  });

  const formik = useFormik({
    initialValues: {
      description: "",
    },
    enableReinitialize: true,
    validationSchema: props.type === "reject" ? validationSchemaReject : validationSchemaApprove,
    onSubmit: (values) => {
      props.action(formik.values)
      formik.resetForm()
    },
  });

  const handleSubmit = () => {
    formik.submitForm()
  }

  return (
    <React.Fragment>
      <Dialog
        onBackdropClick={() => { return false }}
        open={props.open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="form-add-dialog-title" fontSize="1.3rem">
          {props.title}
          <Box sx={{ position: "absolute", right: 0, margin: "15px 18px 0  0", top: 0 }} className="clickable" onClick={handleClose}><img src={CloseIcon} alt="browser" /></Box>
          <Divider sx={{ marginTop: "10px" }} />
        </DialogTitle>
        <DialogContent sx={{ ".MuiFormHelperText-root": { color: " #CC6058 !important", fontSize: "14px", lineHeight: "15.4px" }, ".MuiOutlinedInput-notchedOutline": { "border-color": Boolean(formik.touched.description && formik.errors.description) && Util.formatData(formik.values.description, false) === false ? "#CC6058 !important" : "" } }}>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column', }}>
            {
              props.type === "reject" ?
                <DialogAlert></DialogAlert> : <DialogAlertGreen></DialogAlertGreen>
            }
            <Typography mt="30px" mb="22px" fontSize={16}>{props.text}</Typography>

            {
              props.type === "reject" ?
                <TextField
                  multiline
                  rows={4}
                  margin="dense"
                  id="description"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  fullWidth
                  size="large"
                  placeholder={t("label.fillInTheComments")}
                  helperText={formik.touched.description && formik.errors.description}
                  error={Boolean(formik.touched.description && formik.errors.description)}
                />
                :
                <TextField
                  multiline
                  rows={4}
                  margin="dense"
                  id="description"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  fullWidth
                  size="large"
                  placeholder={t("label.fillInTheComments")}
                // helperText={formik.touched.description && formik.errors.description}
                // error={Boolean(formik.touched.description && formik.errors.description)}
                />
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <Button onClick={handleClose} size="medium" variant="outlined" sx={{ width: '150px', marginRight: "10px", textTransform: "none" }} color="black">{t("label.cancel")}</Button>
          <Button onClick={handleSubmit} size="medium" variant="contained" sx={{ width: '150px', color: "#fff!important", textTransform: "none" }} color={props.type === "reject" ? "red" : "primary"}>{t("label.confirm")}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default ConfirmRejectPerformanceEvaliation;
